/**
 * @fileoverview ユーザー認証状態確認API
 *
 * このファイルでは、現在のユーザーがサインイン済み（認証済み）かどうかを
 * 確認する機能を提供します。
 */

/**
 * 現在のユーザーがサインイン済みかどうかを確認する
 *
 * セッションの有効性をバックエンドAPIに問い合わせることで、
 * 現在のユーザーが認証済み状態にあるかどうかを判定します。
 * この関数は認証状態の確認に使用され、要保護リソースへの
 * アクセス前のチェックなどに利用できます。
 *
 * @returns {Promise<boolean>} ユーザーがサインイン済みの場合はtrue、そうでない場合はfalseを返すPromise
 * @throws {Error} API通信エラーが発生した場合
 */
import { fetchWithLog } from "./_fetchWithLog";

export const isSignedIn = async () => {
  const bffOrigin = import.meta.env.VITE_BFF_ORIGIN;
  const res = await fetchWithLog(`${bffOrigin}/v1/session/status`, {
    credentials: "include",
  });
  return res.ok;
};
